
// import React, { useEffect, useState } from 'react';
// import './formreport.css';
// import axios from 'axios';
// import html2pdf from 'html2pdf.js';

// const FactoryReport = () => {
//   const [reportType, setReportType] = useState('daily');
//   const [fromDate, setFromDate] = useState('');
//   const [toDate, setToDate] = useState('');
//   const [selectedFactory, setSelectedFactory] = useState('');
//   const [factories, setFactories] = useState([]);
//   const [reportData, setReportData] = useState([]);

//   useEffect(() => {
//     fetchFactories();
//   }, []);

//   const fetchFactories = async () => {
//     try {
//       const res = await axios.get('https://kmtea.onrender.com/factoryinfo');
//       setFactories(res.data);
//     } catch (err) {
//       console.error('Failed to load factories', err);
//     }
//   };

//   const formatDate = (dateStr) => new Date(dateStr).toLocaleDateString('en-GB');
//   const formatTime = (dateStr) => {
//     const date = new Date(dateStr);
//     return date.toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit' });
//   };

  
// const getGroupKey = (itemDate) => {
//   const date = new Date(itemDate);

//   if (reportType === 'daily') {
//     return date.toLocaleDateString('en-GB');
//   }

//   if (reportType === 'weekly') {
//     const firstDayOfMonth = new Date(date.getFullYear(), date.getMonth(), 1);
//     const dayOfMonth = date.getDate();
//     const weekOfMonth = Math.ceil((dayOfMonth + firstDayOfMonth.getDay()) / 7);
//     const monthName = date.toLocaleString('default', { month: 'short' });
//     return `Week ${weekOfMonth} - ${monthName} ${date.getFullYear()}`;
//   }

//   if (reportType === 'monthly') {
//     return `${date.toLocaleString('default', { month: 'short' })} ${date.getFullYear()}`;
//   }

//   return '';
// };

//   const fetchReport = async () => {
//     try {
//       const response = await axios.get('https://kmtea.onrender.com/factory');
//       let data = response.data;

//       const now = new Date();
//       const start = fromDate ? new Date(fromDate) : new Date(now.getFullYear(), now.getMonth(), 1);
//       const end = toDate ? new Date(toDate) : new Date(now.getFullYear(), now.getMonth() + 1, 0);

//       data = data.filter(item => {
//         const itemDate = new Date(item.date);
//         return itemDate >= start && itemDate <= end;
//       });

//       if (selectedFactory) {
//         data = data.filter(item => item.factoryname === selectedFactory);
//         setReportData(data.sort((a, b) => new Date(a.date) - new Date(b.date)));
//       } else {
//         const grouped = {};
//         data.forEach(item => {
//           const key = getGroupKey(item.date);
//           if (!grouped[key]) {
//             grouped[key] = {
//               date: key,
//               quantity: 0,
//               water: 0,
//               netweight: 0,
//               price: 0,
//               totalamount: 0,
//               stick: 0,
//               tare: 0,
//               bagqty: 0,
//               count: 0
//             };
//           }
//           grouped[key].quantity += parseFloat(item.quantity || 0);
//           grouped[key].water += parseFloat(item.water || 0);
//           grouped[key].netweight += parseFloat(item.netweight || 0);
//           grouped[key].price += parseFloat(item.price || 0);
//           grouped[key].totalamount += parseFloat(item.totalamount || 0);
//           grouped[key].stick += parseFloat(item.stick || 0);
//           grouped[key].tare += parseFloat(item.tare || 0);
//           grouped[key].bagqty += parseFloat(item.bagqty || 0);
//           grouped[key].count += 1;
//         });

//         const groupedArray = Object.keys(grouped).map(k => ({
//           ...grouped[k],
//           avgNetWeight: (grouped[k].netweight / grouped[k].count).toFixed(2)
//         }));

//         setReportData(groupedArray);
//       }
//     } catch (error) {
//       console.error('Error fetching report:', error);
//     }
//   };

//   const handleDownload = () => {
//     const element = document.querySelector('.farmer-report__table-container');
//     html2pdf().from(element).save('FactoryReport.pdf');
//   };

//   return (
//     <div className="farmer-report__container">
//       <h2>Factory Data Report</h2>

//       <div className="farmer-report__filters">
//         <select value={selectedFactory} onChange={(e) => setSelectedFactory(e.target.value)}>
//           <option value="">All Factories</option>
//           {factories.map(f => (
//             <option key={f.id} value={f.fname}>{f.fname} ({f.farea})</option>
//           ))}
//         </select>

//         <select value={reportType} onChange={(e) => setReportType(e.target.value)}>
//           <option value="daily">Daily</option>
//           <option value="weekly">Weekly</option>
//           <option value="monthly">Monthly</option>
//         </select>

//         <input type="date" value={fromDate} onChange={(e) => setFromDate(e.target.value)} />
//         <input type="date" value={toDate} onChange={(e) => setToDate(e.target.value)} />

//         <button onClick={fetchReport}>Get Report</button>
//         <button onClick={handleDownload} style={{ background: '#28a745' }}>Download</button>
//       </div>

//       {reportData.length > 0 ? (
//         <div className="farmer-report__table-container">
//           <table className="farmer-report__table">
//             <thead>
//               <tr>
//                 {selectedFactory ? (
//                   <>
//                     <th>Date</th>
//                     <th>Factory</th>
//                     <th>Time</th>
//                     <th>Description</th>
//                     <th>Qty</th>
//                     <th>Water</th>
//                     <th>Net</th>
//                     <th>Price</th>
//                     <th>Total</th>
//                     <th>Stick</th>
//                     <th>Tare</th>
//                     <th>Bags</th>
//                     <th>TC</th>
//                   </>
//                 ) : (
//                   <>
//                     <th>{reportType.charAt(0).toUpperCase() + reportType.slice(1)}</th>
//                     <th>Total Qty</th>
//                     <th>Total Water</th>
//                     <th>Total Net</th>
//                     <th>Total Price</th>
//                     <th>Total Amount</th>
//                     <th>Total Stick</th>
//                     <th>Total Tare</th>
//                     <th>Total Bags</th>
//                     <th>Avg Net/Entry</th>
//                   </>
//                 )}
//               </tr>
//             </thead>
//             <tbody>
//               {reportData.map((entry, index) => (
//                 <tr key={index}>
//                   {selectedFactory ? (
//                     <>
//                       <td>{formatDate(entry.date)}</td>
//                       <td>{entry.factoryname || entry.factory}</td>
//                       <td>{formatTime(entry.date)}</td>
//                       <td>{entry.description}</td>
//                       <td>{entry.quantity}</td>
//                       <td>{entry.water}</td>
//                       <td>{entry.netweight}</td>
//                       <td>{entry.price}</td>
//                       <td>{entry.totalamount}</td>
//                       <td>{entry.stick}</td>
//                       <td>{entry.tare}</td>
//                       <td>{entry.bagqty}</td>
//                       <td>{entry.tc}</td>
//                     </>
//                   ) : (
//                     <>
//                       <td>{entry.date}</td>
//                       <td>{entry.quantity.toFixed(2)}</td>
//                       <td>{entry.water.toFixed(2)}</td>
//                       <td>{entry.netweight.toFixed(2)}</td>
//                       <td>{entry.price.toFixed(2)}</td>
//                       <td>{entry.totalamount.toFixed(2)}</td>
//                       <td>{entry.stick.toFixed(2)}</td>
//                       <td>{entry.tare.toFixed(2)}</td>
//                       <td>{entry.bagqty.toFixed(2)}</td>
//                       <td>{entry.avgNetWeight}</td>
//                     </>
//                   )}
//                 </tr>
//               ))}
//             </tbody>
//           </table>
//         </div>
//       ) : (
//         <div className="farmer-report__no-data">No report data available.</div>
//       )}
//     </div>
//   );
// };

// export default FactoryReport;


import React, { useEffect, useState } from 'react';
import './formreport.css';
import axios from 'axios';
import html2pdf from 'html2pdf.js';

const FactoryReport = () => {
  const [reportType, setReportType] = useState('daily');
  const [fromDate, setFromDate] = useState('');
  const [toDate, setToDate] = useState('');
  const [selectedFactory, setSelectedFactory] = useState('');
  const [factories, setFactories] = useState([]);
  const [reportData, setReportData] = useState([]);

  useEffect(() => {
    fetchFactories();
  }, []);

  const fetchFactories = async () => {
    try {
      const res = await axios.get('https://kmtea.onrender.com/factoryinfo');
      setFactories(res.data);
    } catch (err) {
      console.error('Failed to load factories', err);
    }
  };

  const formatDate = (d) => new Date(d).toLocaleDateString('en-GB');
  const formatTime = (d) =>
    new Date(d).toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit' });

  /* ===================== GROUP KEY ===================== */
  const getGroupKey = (itemDate) => {
    const date = new Date(itemDate);

    if (reportType === 'daily')
      return date.toLocaleDateString('en-GB');

    if (reportType === 'weekly') {
      const firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
      const week = Math.ceil((date.getDate() + firstDay.getDay()) / 7);
      return `Week ${week} - ${date.toLocaleString('default', { month: 'short' })} ${date.getFullYear()}`;
    }

    return `${date.toLocaleString('default', { month: 'short' })} ${date.getFullYear()}`;
  };

  /* ===================== FETCH REPORT ===================== */
  const fetchReport = async () => {
    try {
      const res = await axios.get('https://kmtea.onrender.com/factory');
      let data = res.data;

      const now = new Date();
      const start = fromDate ? new Date(fromDate) : new Date(now.getFullYear(), now.getMonth(), 1);
      const end = toDate ? new Date(toDate) : new Date(now.getFullYear(), now.getMonth() + 1, 0);

      data = data.filter(i => {
        const d = new Date(i.date);
        return d >= start && d <= end;
      });

      if (selectedFactory) {
        setReportData(
          data
            .filter(i => i.factoryname === selectedFactory)
            .sort((a, b) => new Date(a.date) - new Date(b.date))
        );
        return;
      }

      const grouped = {};
      data.forEach(i => {
        const key = getGroupKey(i.date);
        if (!grouped[key]) {
          grouped[key] = {
            date: key,
            quantity: 0,
            water: 0,
            netweight: 0,
            price: 0,
            totalamount: 0,
            stick: 0,
            tare: 0,
            bagqty: 0,
            count: 0
          };
        }

        grouped[key].quantity += +i.quantity || 0;
        grouped[key].water += +i.water || 0;
        grouped[key].netweight += +i.netweight || 0;
        grouped[key].price += +i.price || 0;
        grouped[key].totalamount += +i.totalamount || 0;
        grouped[key].stick += +i.stick || 0;
        grouped[key].tare += +i.tare || 0;
        grouped[key].bagqty += +i.bagqty || 0;
        grouped[key].count++;
      });

      setReportData(
        Object.values(grouped).map(g => ({
          ...g,
          avgNetWeight: (g.netweight / g.count).toFixed(2)
        }))
      );
    } catch (err) {
      console.error('Error fetching report:', err);
    }
  };

  /* ===================== GRAND TOTAL ===================== */
  const grandTotal = reportData.reduce(
    (t, i) => {
      t.qty += +i.quantity || 0;
      t.water += +i.water || 0;
      t.net += +i.netweight || 0;
      t.price += +i.price || 0;
      t.amount += +i.totalamount || 0;
      t.stick += +i.stick || 0;
      t.tare += +i.tare || 0;
      t.bag += +i.bagqty || 0;
      return t;
    },
    { qty: 0, water: 0, net: 0, price: 0, amount: 0, stick: 0, tare: 0, bag: 0 }
  );

  /* ===================== PDF ===================== */
  const handleDownload = () => {
    html2pdf().from(document.querySelector('.farmer-report__table-container')).save('FactoryReport.pdf');
  };

  /* ===================== UI ===================== */
  return (
    <div className="farmer-report__container">
      <h2>Factory Data Report</h2>

      <div className="farmer-report__filters">
        <select value={selectedFactory} onChange={(e) => setSelectedFactory(e.target.value)}>
          <option value="">All Factories</option>
          {factories.map(f => (
            <option key={f.id} value={f.fname}>{f.fname} ({f.farea})</option>
          ))}
        </select>

        <select value={reportType} onChange={(e) => setReportType(e.target.value)}>
          <option value="daily">Daily</option>
          <option value="weekly">Weekly</option>
          <option value="monthly">Monthly</option>
        </select>

        <input type="date" value={fromDate} onChange={(e) => setFromDate(e.target.value)} />
        <input type="date" value={toDate} onChange={(e) => setToDate(e.target.value)} />

        <button onClick={fetchReport}>Get Report</button>
        <button onClick={handleDownload} style={{ background: '#28a745' }}>Download</button>
      </div>

      {reportData.length > 0 && (
        <div className="farmer-report__table-container">
          <table className="farmer-report__table">
            <thead>
              <tr>
                {selectedFactory ? (
                  <>
                    <th>Date</th><th>Factory</th><th>Time</th><th>Description</th>
                    <th>Qty</th><th>Water</th><th>Net</th><th>Price</th>
                    <th>Total</th><th>Stick</th><th>Tare</th><th>Bags</th><th>TC</th>
                  </>
                ) : (
                  <>
                    <th>{reportType.toUpperCase()}</th>
                    <th>Qty</th><th>Water</th><th>Net</th><th>Price</th>
                    <th>Amount</th><th>Stick</th><th>Tare</th><th>Bags</th><th>Avg Net</th>
                  </>
                )}
              </tr>
            </thead>

            <tbody>
              {reportData.map((e, i) => (
                <tr key={i}>
                  {selectedFactory ? (
                    <>
                      <td>{formatDate(e.date)}</td>
                      <td>{e.factoryname}</td>
                      <td>{formatTime(e.date)}</td>
                      <td>{e.description}</td>
                      <td>{e.quantity}</td>
                      <td>{e.water}</td>
                      <td>{e.netweight}</td>
                      <td>{e.price}</td>
                      <td>{e.totalamount}</td>
                      <td>{e.stick}</td>
                      <td>{e.tare}</td>
                      <td>{e.bagqty}</td>
                      <td>{e.tc}</td>
                    </>
                  ) : (
                    <>
                      <td>{e.date}</td>
                      <td>{e.quantity.toFixed(2)}</td>
                      <td>{e.water.toFixed(2)}</td>
                      <td>{e.netweight.toFixed(2)}</td>
                      <td>{e.price.toFixed(2)}</td>
                      <td>{e.totalamount.toFixed(2)}</td>
                      <td>{e.stick.toFixed(2)}</td>
                      <td>{e.tare.toFixed(2)}</td>
                      <td>{e.bagqty.toFixed(2)}</td>
                      <td>{e.avgNetWeight}</td>
                    </>
                  )}
                </tr>
              ))}

              {/* ===== GRAND TOTAL ===== */}
              <tr className="grand-total-row">
                <td><strong>Grand Total</strong></td>
                {!selectedFactory && <td><strong>{grandTotal.qty.toFixed(2)}</strong></td>}
                {selectedFactory ? (
                  <>
                    <td colSpan="3"></td>
                    <td><strong>{grandTotal.qty.toFixed(2)}</strong></td>
                    <td><strong>{grandTotal.water.toFixed(2)}</strong></td>
                    <td><strong>{grandTotal.net.toFixed(2)}</strong></td>
                    <td><strong>{grandTotal.price.toFixed(2)}</strong></td>
                    <td><strong>{grandTotal.amount.toFixed(2)}</strong></td>
                    <td><strong>{grandTotal.stick.toFixed(2)}</strong></td>
                    <td><strong>{grandTotal.tare.toFixed(2)}</strong></td>
                    <td><strong>{grandTotal.bag.toFixed(2)}</strong></td>
                    <td></td>
                  </>
                ) : (
                  <>
                    <td><strong>{grandTotal.water.toFixed(2)}</strong></td>
                    <td><strong>{grandTotal.net.toFixed(2)}</strong></td>
                    <td><strong>{grandTotal.price.toFixed(2)}</strong></td>
                    <td><strong>{grandTotal.amount.toFixed(2)}</strong></td>
                    <td><strong>{grandTotal.stick.toFixed(2)}</strong></td>
                    <td><strong>{grandTotal.tare.toFixed(2)}</strong></td>
                    <td><strong>{grandTotal.bag.toFixed(2)}</strong></td>
                    <td></td>
                  </>
                )}
              </tr>
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default FactoryReport;
